import { Card, Progress } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { getScrapingBeeUsage } from '../fb-functions';


const ScrapingBeeUsage = () => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsage = async () => {
      try {
        const response = await getScrapingBeeUsage(); // proxy endpoint
        console.log(response)
        setUsage(response.data);
      } catch (error) {
        console.error('Failed to fetch usage data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsage();
  }, []);

  if (loading) return <p className="text-center">Loading...</p>;
  if (!usage) return <p className="text-center text-red-500">Failed to load usage data.</p>;

  const { used_api_credit, max_api_credit, current_concurrency, max_concurrency } = usage;
  const creditUsagePercent = Math.round((used_api_credit / max_api_credit) * 100);
  const concurrencyPercent = Math.round((current_concurrency / max_concurrency) * 100);

  return (
    <Card className="max-w-xl p-6 space-y-4 shadow-lg">
        <div>
          <h2 className="text-xl font-bold">SB API Usage</h2>
          <Progress value={creditUsagePercent} />
          <div className="mt-2 flex justify-between text-sm">
            <span>{used_api_credit} / {max_api_credit} credits used</span>
            <Badge>{creditUsagePercent}%</Badge>
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold">Concurrency</h2>
          <Progress value={concurrencyPercent} />
          <div className="mt-2 flex justify-between text-sm">
            <span>{current_concurrency} / {max_concurrency} in use</span>
            <Badge>{concurrencyPercent}%</Badge>
          </div>
        </div>
    </Card>
  );
};

export default ScrapingBeeUsage;
